<template>
  <div class="dialog-wrap">
    <el-dialog title="学员信息"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="451px">
      <el-form class="search-wrap"
               ref="formRules"
               :model="dataForm"
               :rules="rules"
               label-width="130px"
               label-position="left">
        <el-form-item label="本科院校分类："
                      prop="origin_college_category_ids">
          <el-select v-model="dataForm.origin_college_category_ids"
                     placeholder="请选择"
                     style="width: 100%"
                     clearable>
            <el-option v-for="(item, index) in options"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否跨专业："
                      prop="origin_major">
          <el-select v-model="dataForm.origin_major"
                     placeholder="请选择"
                     filterable
                     clearable
                     style="width:100%;">

            <el-option label="是"
                       :value="1">
            </el-option>
            <el-option label="否"
                       :value="0">
            </el-option>
          </el-select>

        </el-form-item>
        <el-form-item label="报考院校："
                      prop="apply_college">
          <el-select v-model="dataForm.apply_college"
                     filterable
                     placeholder="请选择"
                     @change="apply_collegeChange"
                     style="width: 100%"
                     clearable>
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报考专业："
                      prop="apply_major">
          <el-select v-model="dataForm.apply_major"
                     placeholder="请选择"
                     filterable
                     clearable
                     style="width: 100%"
                     @change="apply_majorChange">
            <el-option v-for="(item, index) in apply_majorList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="初试总分："
                      prop="exam_score_total">
          <el-input placeholder="请输入初试总分"
                    v-model="dataForm.exam_score_total">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>

        <el-form-item label="学习方式：">
          <el-select v-model="dataForm.apply_enrol_type"
                     filterable
                     placeholder="请选择"
                     style="width: 100%"
                     clearable>
            <el-option v-for="(item, index) in learningOption"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报考照顾类型:">
          <el-select v-model="dataForm.apply_care_type"
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="(item, index) in careOptions"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="推荐范围：">
          <el-select v-model="dataForm.report_view_type"
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="(item, index) in viewOptions"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="意向地区："
                      prop="province_code">
          <el-select v-model="dataForm.mind_college_province_codes"
                     style="width: 100%"
                     clearable
                     placeholder="请选择"
                     multiple
                     :multiple-limit="3">
            <el-option v-for="item in provinces"
                       :key="item.code"
                       :label="item.name"
                       :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="意向分类：">
          <el-select v-model="dataForm.mind_college_category_ids"
                     style="width: 100%"
                     clearable
                     placeholder="请选择"
                     multiple
                     :multiple-limit="3">
            <el-option v-for="item in intentionOptions"
                       :key="item.label"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="意向学习方式：">
          <el-select v-model="dataForm.mind_enrol_type"
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="(item, index) in mindLearnOptions"
                       :key="index"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="可调剂专业：">
          <el-select v-model="dataForm.arr_extend_major"
                     style="width: 100%"
                     placeholder="请选择"
                     multiple
                     filterable
                     @change="$forceUpdate()">
            <el-option v-for="(item,index) in adjustableMajorOptions"
                       :key="index"
                       :label="`（${item.extend_major_code}）${item.extend_major_name}`"
                       :value="{ value: item.extend_major_code, label: item.extend_major_name }">
              <span>{{ `（${item.extend_major_code}）${item.extend_major_name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="其他意向专业："
                      prop="arr_apply_major">
          <el-select v-model="dataForm.arr_apply_major"
                     style="width: 100%"
                     placeholder="请选择"
                     multiple
                     filterable
                     :multiple-limit="10"
                     @change="$forceUpdate()">
            <el-option v-for="(item,index) in allMajorList"
                       :key="index"
                       :label="`（${item.code}）${item.name}`"
                       :value="{ value: item.code, label: item.name }">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer"
           class="footer">
        <el-button @click="handleClose()">取消</el-button>
        <el-button type="primary"
                   @click="submit('formRules')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
        
  <script>
import {
  collegeMajorList,
  majorSubjectList,
  academyList,
  majorinfo,
  majorList,
} from '@/api/common'
import { getAdjustableMajorList } from '@/api/adjust'
export default {
  components: {},
  props: {
    provinces: {
      default: [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      allMajorList: [],
      dialogVisible: this.visible,
      dataForm: {
        origin_college_category_ids: 1,
        apply_enrol_type: '1',
        mind_enrol_type: 1,
        mind_college_province_codes: ['null'],
        mind_college_category_ids: [''],
      },
      rules: {
        origin_college_category_ids: [
          { required: true, message: '请选择本科院校分类', trigger: 'blur' },
        ],
        // origin_major: [{ required: true, message: "请选择本科专业", trigger: "blur" }],
        apply_college: [
          { required: true, message: '请选择报考院校', trigger: 'blur' },
        ],
        apply_major: [
          { required: true, message: '请选择报考专业', trigger: 'blur' },
        ],
        exam_score_total: [
          { required: true, message: '请输入初试总分', trigger: 'blur' },
        ],
      },
      origin_majorList: [],
      apply_majorList: [],
      adjustableMajorOptions: [],
      careOptions: [
        {
          label: '报考非照顾类',
          value: 0,
        },
        {
          label: '报考少干',
          value: 1,
        },
        {
          label: '报考士兵计划',
          value: 2,
        },
      ],
      viewOptions: [
        {
          label: '看所有院校',
          value: 0,
        },
        {
          label: '只看少干院校',
          value: 1,
        },
        {
          label: '只看士兵计划院校',
          value: 2,
        },
      ],
      mindLearnOptions: [
        {
          label: '全日制',
          value: 1,
        },
        {
          label: '非全日制',
          value: 2,
        },
        {
          label: '不限',
          value: 3,
        },
      ],
      learningOption: [
        {
          label: '全日制',
          value: '1',
        },
        {
          label: '非全日制',
          value: '2',
        },
      ],
      intentionOptions: [
        {
          label: '985',
          value: '1',
        },
        {
          label: '211',
          value: '2',
        },
        {
          label: '双一流',
          value: '3,4',
        },
        {
          label: '双非',
          value: '7',
        },
        {
          label: '不限',
          value: '',
        },
      ],
      options: [
        {
          label: '985',
          value: 1,
        },
        {
          label: '211',
          value: 2,
        },
        {
          label: '双一流',
          value: '3,4',
        },
        {
          label: '双非',
          value: ' ',
        },
      ],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      this.getAllMajorList()
    },
  },
  created() {},
  methods: {
    fetchAdjustableMajor(major_code) {
      console.log('fetchAdjustableMajor')
      getAdjustableMajorList({
        isPaging: 0,
        major_code: major_code,
      }).then((res) => {
        this.adjustableMajorOptions = res.arr_adjustable_major || []
      })
    },
    apply_majorChange(e) {
      this.fetchAdjustableMajor(e.value)
    },
    getAllMajorList(e) {
      majorList({ isPaging: 0 }).then((res) => {
        this.allMajorList = []
        res.list.forEach((item) => {
          if (item.children) {
            this.recursion(item.children)
          }
        })
        console.log('allMajorList:', this.allMajorList)
      })
    },
    recursion(node) {
      node.forEach((item) => {
        if (item.children) {
          this.recursion(item.children)
        } else {
          this.allMajorList.push(item)
        }
      })
    },

    origin_collegeChange(e) {
      collegeMajorList({ college_code: e.value, isPaging: 0 }).then((res) => {
        this.origin_majorList = res.list
      })
    },
    apply_collegeChange(e) {
      collegeMajorList({ college_code: e.value, isPaging: 0 }).then((res) => {
        this.apply_majorList = res.list
      })
    },
    handleClose() {
      this.$emit('close')
    },

    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          const data = {
            apply_college_code: this.dataForm.apply_college.value,
            apply_major_code: this.dataForm.apply_major.value,
            apply_major_name: this.dataForm.apply_major.label,
            apply_college_name: this.dataForm.apply_college.label,
            exam_score_total: this.dataForm.exam_score_total,
            origin_college_category_ids:
              this.dataForm.origin_college_category_ids + '',
            apply_enrol_type: this.dataForm.apply_enrol_type,
            apply_care_type: this.dataForm.apply_care_type,
            report_view_type: this.dataForm.report_view_type,
            mind_enrol_type: this.dataForm.mind_enrol_type,
            mind_college_province_codes:
              this.dataForm.mind_college_province_codes.includes('null')
                ? ''
                : this.dataForm.mind_college_province_codes.join(),
            mind_college_category_ids:
              this.dataForm.mind_college_category_ids.includes('')
                ? ''
                : this.dataForm.mind_college_category_ids.join(),
            // arr_apply_major_code_sub:
            //   this.dataForm.arr_apply_major_code_sub.join(',,'),
            apply_major_code_subs: this.dataForm.arr_apply_major
              .map((item) => item.value)
              .join(','),
            apply_major_name_subs: this.dataForm.arr_apply_major
              .map((item) => item.label)
              .join(','),
            arr_extend_major: this.dataForm.arr_extend_major.map((item) => ({
              extend_major_code: item.value,
              extend_major_name: item.label,
            })),
            // origin_major_code: this.dataForm.origin_major == 1 ? '000000' : this.dataForm.apply_major
            //   .value,
          }
          if (data.mind_college_province_codes == 'null') {
            delete data.mind_college_province_codes
          }
          if (data.mind_college_category_ids == 'null') {
            delete data.mind_college_category_ids
          }
          // console.log("data", data);
          this.$emit('submit', { data: data })
          this.handleClose()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
  <style lang="less" scoped>
</style>
        